(() => {
  if (customElements.get('pr-announcement-bar')) return;

  class PRAnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.sectionId = this.dataset.sectionId || 'default';
      this.storageKey = `prAnnouncementDismissed:${this.sectionId}`;
      this.closeButton = this.querySelector('[data-pr-announcement-close]');

      if (this.dataset.dismissible !== 'true' || !this.closeButton) return;

      this.onClose = this.dismiss.bind(this);
      this.onSectionSelect = this.handleSectionSelect.bind(this);

      this.closeButton.addEventListener('click', this.onClose);
      document.addEventListener('shopify:section:select', this.onSectionSelect);
      document.addEventListener('shopify:block:select', this.onSectionSelect);

      if (!window.Shopify?.designMode && this.readDismissed()) {
        this.hidden = true;
      }
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.closeButton?.removeEventListener('click', this.onClose);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:block:select', this.onSectionSelect);
      this.initialized = false;
    }

    dismiss() {
      this.hidden = true;

      if (window.Shopify?.designMode) return;

      try {
        sessionStorage.setItem(this.storageKey, '1');
      } catch (error) {
        // The bar can still be dismissed when storage is blocked by privacy settings.
      }
    }

    handleSectionSelect(event) {
      if (event.detail?.sectionId !== this.sectionId) return;
      this.hidden = false;
    }

    readDismissed() {
      try {
        return sessionStorage.getItem(this.storageKey) === '1';
      } catch (error) {
        return false;
      }
    }
  }

  customElements.define('pr-announcement-bar', PRAnnouncementBar);
})();
